import { OTHER_ITEM, PERIOD } from "./revenueMetrics";

export const VIEW_BY_OPTIONS = [
  { value: PERIOD.TOTALS, label: "Date" },
  { value: PERIOD.MONTHLY, label: "Month" },
  { value: PERIOD.QUARTERLY, label: "Quarter" },
  { value: PERIOD.YEARLY, label: "Year" },
];

export const OTHER_OPTIONS = [
  { value: OTHER_ITEM.MERCHANT, label: "Merchant" },
];

export const COMPARE_BY = {
  PREVIOUS_PERIOD: "PREVIOUS_PERIOD",
  PREVIOUS_YEAR: "PREVIOUS_YEAR",
} as const;

export type CompareByType = keyof typeof COMPARE_BY | null;

export const COMPARE_BY_OPTIONS = [
  { value: COMPARE_BY.PREVIOUS_PERIOD, label: "Previous period" },
  { value: COMPARE_BY.PREVIOUS_YEAR, label: "Previous year" },
];

export const VARIANCE = {
  AMOUNT: "AMOUNT",
  PERCENTAGE: "PERCENTAGE",
} as const;

export type VarianceType = keyof typeof VARIANCE;

export const VARIANCE_OPTIONS = [
  { value: VARIANCE.AMOUNT, label: "Amount ($)" },
  { value: VARIANCE.PERCENTAGE, label: "Percentage (%)" },
];

export const COMPARE_PERIOD = {
  CURRENT: "CURRENT",
  PREVIOUS: "PREVIOUS",
} as const;

export const COLUMN_IDS = {
  CURRENT_PERIOD: "current_period",
  COMPARISON_PERIOD: "comparison_period",
  VARIANCE_AMOUNT: "variance_amount",
  VARIANCE_PERCENTAGE: "variance_percentage",
  EXPLANATION: "explanation",
} as const;

export const PERCENTAGE_MODE = {
  REVENUE: "REVENUE",
  INCOME: "INCOME",
} as const;

export type PercentageModeType = keyof typeof PERCENTAGE_MODE;

export const PERCENTAGE_MODE_OPTIONS = [
  {
    value: PERCENTAGE_MODE.REVENUE,
    label: "% of Operating Revenue",
    tooltip:
      "Calculates values based on core business operations only. Best for analyzing operational efficiency and margins.",
  },
  {
    value: PERCENTAGE_MODE.INCOME,
    label: "% of Total Income",
    tooltip:
      "Calculates values based on all income sources, including Operating Revenue and Other Income (Dividends, Interest, etc.).",
  },
];

export const PERCENTAGE_MODE_LABELS = {
  [PERCENTAGE_MODE.REVENUE]: "Operating Revenue",
  [PERCENTAGE_MODE.INCOME]: "Total Income",
} as const;

export type ColumnIdType = (typeof COLUMN_IDS)[keyof typeof COLUMN_IDS];

export const VARIANCE_COLUMN = "Variance";

export const TOTALS_COLUMN = "Totals";

export const CITED_ENTITY_TYPE = {
  CATEGORY: "CATEGORY",
  VENDOR: "VENDOR",
} as const;

export const VARIANCE_CHIP_SENTIMENT = {
  FAVORABLE: "favorable",
  UNFAVORABLE: "unfavorable",
  NEUTRAL: "neutral",
} as const;
